import FixedHeader from './FixedHeader'
import './OverlayContent.sass'
import {Spin} from 'antd'

export default function OverlayContent({loading = false, active = false, children, onClose = undefined, classes = "", showHeader = true}) {
  return (

    <div className={`overlay-content-wrapper ${classes} ${active ? 'active' : ''}`}>
      {showHeader && <FixedHeader onClose={onClose}/>}
      <Spin spinning={loading} size="large" fullscreen/>
        <div className="overlay-content">
          {children}
        </div>
      <div className="menu-spacer"></div>
    </div>
  )
}